import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable } from "rxjs";
import { OrderAppType } from "../helpers/helper.common";
import { API } from "./paymentapiroutes";

import { CoreService } from "./core.service";

@Injectable({
  providedIn: "root",
})
export class basketService {
  constructor(private apiService: ApiService) {}

  Promocode(retailerId: number, Promocode: string): Observable<any> {
    return this.apiService.get(
      API.PROMOCODE +
        retailerId +
        `/promocode/` +
        Promocode +
        `?App_from=` +
        OrderAppType.webapp
    );
  }

  StoreBasketItem(baket): Observable<any> {
    var userId;
    var Request = {};
    if (localStorage.getItem("currentUser")) {
      var currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
      if (currentUser?.user) {
        userId = currentUser?.user?.id;
      }
    }

    if (userId != undefined) {
      Request = {
        items: baket,
      };
      var data = this.apiService.post(
        API.STOREBASKET +
          "?user_id=" +
          userId +
          "&retailer_id=" +
          CoreService.retailerId,
        Request
      );
    }
    return data;
  }

  DeleteBasketItem(): Observable<any> {
    var userId;
    var Request = {};
    if (localStorage.getItem("currentUser")) {
      var currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
      if (currentUser?.user) {
        userId = currentUser?.user?.id;
      }
    }
    if (userId != undefined) {
      if (userId) {
        var data = this.apiService.post(
          API.DELETEBASKET +
            "?user_id=" +
            userId +
            "&retailer_id=" +
            CoreService.retailerId,
          Request
        );
      }
    }
    return data;
  }

  CheckForStoredBasket(): Observable<any> {
    var userId;
    if (localStorage.getItem("currentUser")) {
      var currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
      if (currentUser?.user) {
        userId = currentUser?.user?.id;
      }
    }

    if (userId != undefined) {
      if (CoreService.retailerId != 0)
        var data = this.apiService.get(
          API.CHECKFORBASKET +
            "?user_id=" +
            userId +
            "&retailer_id=" +
            CoreService.retailerId
        );
    }
    return data;
  }

  GetStoredBasket(): Observable<any> {
    var userId;
    if (localStorage.getItem("currentUser")) {
      var currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
      if (currentUser?.user) {
        userId = currentUser?.user?.id;
      }
    }

    var data = this.apiService.get(
      API.FETCHBASKET +
        "?user_id=" +
        userId +
        "&retailer_id=" +
        CoreService.retailerId
    );
    return data;
  }
}
